var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBarcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M0 9h17V8H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8 0v17h1V0zM2 2v3h3V2H2zM0 0h7v7H0V0zM12 5h3V2h-3v3zm-2-5h7v7h-7V0zM2 15h3v-3H2v3zm-2-5h7v7H0v-7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14h3v3h-3zM10 10h1v3h-1zM12 11h3v1h-3zM14 13h1v4h-1zM16 10h1v7h-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10h1v3h-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBarcode);
export default __webpack_public_path__ + "static/media/icon-barcode.9990d0078401b3cb4b4b5834cfe9cb32.svg";
export { ForwardRef as ReactComponent };